// eslint-disable-next-line import/prefer-default-export
export const typography = {
  fontFamily: ['Muli'],
  fontSize: 13,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontSize: 78,
    fontWeight: 400,
    lineHeight: 1.167,
    letterSpacing: '-0.01562em',
  },
  h2: {
    fontSize: 48.75,
    fontWeight: 400,
    lineHeight: 1.2,
    letterSpacing: '-0.000833em',
  },
  h3: {
    fontSize: 39,
    fontWeight: 400,
    lineHeight: 1.167,
    letterSpacing: 0,
  },
  h4: {
    fontSize: 27.625,
    fontWeight: 400,
    lineHeight: 1.235,
    letterSpacing: '-0.00735em',
  },
  h5: {
    fontSize: 19.5,
    fontWeight: 400,
    lineHeight: 1.334,
    letterSpacing: '0em',
  },
  h6: {
    fontSize: 16.25,
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: '0.0075em',
  },
  subtitle1: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  },
  subtitle2: {
    fontSize: 12,
    color: '#A8A4B3',
    fontWeight: 700,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  },
  body1: {
    fontWeight: 400,
    fontSize: 13,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  },
  body2: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  },
  button: {
    fontWeight: 700,
    fontSize: 13,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
    textTransform: 'none',
  },
  caption: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  },
};
